import {Component, EventEmitter, HostBinding, HostListener, Input, Output} from "@angular/core";

@Component({
    selector: "fui-command",
    styleUrls: ["./command.component.scss"],
    templateUrl: "./command.component.html",
    standalone: false
})
export class FUICommandComponent {
    @Output() public clicked$: EventEmitter<Event>;
    @Input() public title: string;
    @Input() @HostBinding("class.disabled") public disabled: boolean;

    constructor() {
        this.clicked$ = new EventEmitter<Event>();
    }

    /**
     * Run an event emitter that can be used to hook
     * in actions
     */
    @HostListener("click")
    click(): void {
        this.clicked$.emit();
    }
}
